/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["star-rating-overlay{display:flex;align-items:center;box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12);border-radius:4px;background-color:var(--be-background);padding:10px 18px 10px 10px;color:rgba(0,0,0,.7)}star-rating-overlay .stars{padding-left:5px;margin-left:5px;border-left:1px solid var(--be-divider-default)}"];
export { styles as styles };
